import 'react-responsive-carousel/lib/styles/carousel.min.css';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { SlideContext } from '../AdminPanel/context/SlideContext';
import { VideoContext } from '../AdminPanel/context/VideoContext';
import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';
import { Box } from '@mui/material';
import logoImage from '../img/logoaf.jpg';

const MEDIA_STYLE = {
  width: '100%',
  height: 'clamp(200px, 50vh, 420px)',
  objectFit: 'cover',
  backgroundColor: '#f5f5f5',
  display: 'block',
};

const Carousel = () => {
  const { videos } = useContext(VideoContext);
  const { slides } = useContext(SlideContext);
  const [items, setItems] = useState([]);
  const [mode, setMode] = useState(null); // 'video' | 'slide'
  const [isLoading, setIsLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const videoRefs = useRef([]);

  useEffect(() => {
    setIsLoading(true);

    const validVideos = Array.isArray(videos)
      ? videos.filter((item) => item && item.video)
      : [];

    if (validVideos.length > 0) {
      setItems(validVideos);
      setMode('video');
      setIsLoading(false);
      return;
    }

    const validSlides = Array.isArray(slides)
      ? slides.filter((slide) => slide && slide.image)
      : [];

    if (validSlides.length > 0) {
      setItems(validSlides);
      setMode('slide');
    } else {
      setItems([{ image: logoImage, title: 'Varsayılan Slayt' }]);
      setMode('slide');
    }

    setIsLoading(false);
  }, [videos, slides]);

  useEffect(() => {
    if (mode !== 'video') return;

    videoRefs.current.forEach((videoEl, index) => {
      if (!videoEl) return;
      if (index === selectedIndex) {
        videoEl.currentTime = 0;
        videoEl.play().catch(() => {});
      } else {
        videoEl.pause();
      }
    });
  }, [selectedIndex, items, mode]);

  if (isLoading) {
    return (
      <Box
        sx={{
          width: '100%',
          maxWidth: '100%',
          mx: 'auto',
          mt: 1,
          borderRadius: '12px',
          overflow: 'hidden',
          boxSizing: 'border-box',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
        }}
      >
        <div>Yükleniyor...</div>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        mx: 'auto',
        mt: 1,
        borderRadius: '12px',
        overflow: 'hidden',
        boxSizing: 'border-box',
        minHeight: '300px',
      }}
      className="carousel-container"
    >
      <ResponsiveCarousel
        showArrows={items.length > 1}
        showThumbs={false}
        autoPlay={items.length > 1}
        infiniteLoop={true}
        interval={mode === 'video' ? 8000 : 5000}
        showStatus={false}
        showIndicators={items.length > 1}
        dynamicHeight={false}
        stopOnHover={true}
        swipeable={true}
        emulateTouch={true}
        useKeyboardArrows={true}
        preventMovementUntilSwipeScrollTolerance={true}
        swipeScrollTolerance={50}
        onChange={(index) => setSelectedIndex(index)}
      >
        {mode === 'video'
          ? items.map((item, index) => (
              <div key={item.id || index}>
                <video
                  ref={(el) => {
                    videoRefs.current[index] = el;
                  }}
                  src={item.video}
                  title={item.title || `Video ${index + 1}`}
                  style={{ ...MEDIA_STYLE, backgroundColor: '#000' }}
                  muted
                  playsInline
                  loop
                  autoPlay={index === 0}
                  controls={false}
                />
              </div>
            ))
          : items.map((slide, index) => (
              <div key={slide.id || index}>
                <img
                  src={slide.image}
                  alt={slide.title || `Slide ${index + 1}`}
                  style={MEDIA_STYLE}
                  onError={(e) => {
                    e.target.src = logoImage;
                  }}
                />
              </div>
            ))}
      </ResponsiveCarousel>
    </Box>
  );
};

export default Carousel;
